import SvgIcon from '../SvgIcon/index.vue'
import cElPageHeader from '../cElPageHeader/index.vue'
import cElEmpty from '../cElEmpty/index.vue'

const compList = [SvgIcon, cElPageHeader, cElEmpty]
export function registerGlobComp (app) {
  compList.forEach((comp) => {
    app.component(comp.name || comp.displayName, comp)
  })
}
